import React, { ReactNode } from 'react';
import { Collapse as AntCollapse } from 'antd';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import styles from './Collapse.module.less';

type CollapseProps = {
  header: ReactNode;
  children: ReactNode;
  isExpanded?: boolean;
  className?: string;
};

const iconPlus: IconProp = ['fal', 'plus'];
const iconMinus: IconProp = ['fal', 'minus'];

const Collapse: React.FC<CollapseProps> = ({ className, header, children, isExpanded }) => {
  const defaultActiveKey = isExpanded ? ['1'] : [];
  return (
    <AntCollapse
      bordered={false}
      expandIconPosition={'right'}
      defaultActiveKey={defaultActiveKey}
      expandIcon={({ isActive }) => <FontAwesomeIcon size={'lg'} icon={isActive ? iconMinus : iconPlus} />}
      className={clsx(styles.container, className)}
    >
      <AntCollapse.Panel header={header} key="1" className={styles.panel}>
        {children}
      </AntCollapse.Panel>
    </AntCollapse>
  );
};
export default Collapse;
